export {default} from '../../../core/components/Repository/FieldAutocompleteMultiple';